/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */
/**
 *
 * @author Fedorov Maxim
 * @author Aleksandr Perkhunov
 * @version 1.2.0
 * @since 1.0.1
 */

import { createSelector, OutputSelector } from 'reselect';

import { IRootReducer } from '../../../../../reducers/rootReducer';
import { EWidgetStatus } from '../widgetTypes';
import { IWidgetInquiries, IWidgetOrderInquiriesReducer, IWidgetOrders } from './widgetOrderInquiriesTypes';

export const getOrderInquiries = (state: IRootReducer): IWidgetOrderInquiriesReducer =>
    state.dashboard.widgetOrderInquiries;

export const makeSelectorOrderIsLoading =
    (): OutputSelector<IRootReducer, boolean, (state: IWidgetOrderInquiriesReducer) => boolean> =>
        createSelector(
            getOrderInquiries,
            (state: IWidgetOrderInquiriesReducer) => state.loadingOrder,
        );

export const makeSelectorInquiriesIsLoading =
    (): OutputSelector<IRootReducer, boolean, (state: IWidgetOrderInquiriesReducer) => boolean> =>
        createSelector(
            getOrderInquiries,
            (state: IWidgetOrderInquiriesReducer) => state.loadingInquiries,
        );

export const makeSelectorOrdersGetOrders =
    (): OutputSelector<IRootReducer, IWidgetOrders[], (state: IWidgetOrderInquiriesReducer) => IWidgetOrders[]> =>
        createSelector(
            getOrderInquiries,
            (state: IWidgetOrderInquiriesReducer) => state.orders,
        );

export const makeSelectorInquiriesGetInquiries =
    (): OutputSelector<IRootReducer, IWidgetInquiries[], (state: IWidgetOrderInquiriesReducer) => IWidgetInquiries[]> =>
        createSelector(
            getOrderInquiries,
            (state: IWidgetOrderInquiriesReducer) => state.inquiries,
        );

export const makeSelectorOrderStatus =
    (): OutputSelector<IRootReducer, EWidgetStatus, (state: IWidgetOrderInquiriesReducer) => EWidgetStatus> =>
        createSelector(
            getOrderInquiries,
            (state: IWidgetOrderInquiriesReducer) => state.errorOrder
                ? EWidgetStatus.ERROR
                : state.orders.length ? EWidgetStatus.SUCCESS : EWidgetStatus.EMPTY,
        );

export const makeSelectorInquiriesStatus =
    (): OutputSelector<IRootReducer, EWidgetStatus, (state: IWidgetOrderInquiriesReducer) => EWidgetStatus> =>
        createSelector(
            getOrderInquiries,
            (state: IWidgetOrderInquiriesReducer) => state.errorInquiries
                ? EWidgetStatus.ERROR
                : state.inquiries.length ? EWidgetStatus.SUCCESS : EWidgetStatus.EMPTY,
        );
